export const getEnv = () => {
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV.toString().toLowerCase();
  }
  return null;
};
export const SITE_URL = () => {
  const env = getEnv();
  switch (env) {
    case "stg":
      return "https://s-themaker.circul.us/";
    case "ops":
      return "https://themaker.circul.us/";
    default:
      return "http://localhost:3000/";
  }
};
export const API_URL = () => {
  const env = getEnv();
  switch (env) {
    case "stg":
      return "https://s-lapi.circul.us/v1/";
    case "ops":
      return "https://o-lapi.circul.us/v1/";
    default:
      return "https://o-lapi.circul.us/v1/";
    // return "http://localhost:39411/v1/";
    // return "http://localhost:39411/v1/";
  }
};
const IAPI_URL = () => {
  const env = getEnv();
  switch (env) {
    case "stg":
      return "https://s-iapi.circul.us/v1/";
    case "ops":
      return "https://api-intgr.circul.us/v1/";
    default:
      return "https://api-intgr.circul.us/v1/";
    // return "http://localhost:39730/v1/";
    // return "http://localhost:59730/v1/";
  }
};

export const POST = "POST";
export const PATCH = "PATCH";
export const PUT = "PUT";
export const DELETE = "DELETE";
export const GET = "GET";

export const encodeGetParams = (p) =>
  Object.entries(p)
    .map((kv) => kv.map(encodeURIComponent).join("="))
    .join("&");

export const setAPI = (method, body, isFile) => {
  // const url = `${API_URL()}${path}`;
  let headers = {
    method,
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Access-Control-Allow-Origin": SITE_URL(),
      "Access-Control-Allow-Methods": method,
      "Content-Type": "application/json",
    },
  };
  if (method === GET && body && "token" in body) {
    headers = {
      method,
      mode: "cors",
      headers: {
        "x-access-token": body.token,
        "Access-Control-Allow-Origin": SITE_URL(),
        "Access-Control-Allow-Methods": method,
      },
    };
  } else if (method !== GET && isFile) {
    headers = {
      method,
      mode: "cors",
      headers: {
        Accept: "*/*",
      },
    };
  }
  if (body && method !== GET) {
    headers.body = isFile ? body : JSON.stringify(body);
  }
  // return { url, headers };
  return headers;
};

// getFetchResult('user', POST, formData, true);
export const getFetchResult = async (route, method, data, isFile = false) => {
  const url = `${API_URL()}${route}`;
  const headers = setAPI(method, data, isFile);
  const res = await fetch(url, headers);
  const result = res.json();
  return result;
};

export const getIAPIFetchResult = async (
  route,
  method,
  data,
  isFile = false
) => {
  const url = `${IAPI_URL()}${route}`;
  const headers = setAPI(method, data, isFile);
  const res = await fetch(url, headers);
  const result = res.json();
  return result;
};

export const getIAPIAuthCheck = async (token) => {
  const url = `${IAPI_URL()}auth/check`;
  const res = await fetch(url, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Access-Control-Allow-Origin": SITE_URL(),
      "Access-Control-Allow-Methods": "GET",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const result = res.json();
  return result;
};
